import {EventBus} from '@/event-bus.js';
import {getField, updateField} from 'vuex-map-fields';
import DEFINES from '@/defines';
import router from '@/router';
import * as API from '@/api';

function initialState () {
  return {
    film: {
      uploads: [],
    },
  };
}

const state = initialState ();

// actions

const actions = {
  async get (context, payload) {
    //get uploaded files
    var response = await API.files.get (payload);
    context.commit ('set_files', {
      model_type: payload.model_type,
      files: response.files,
    });
    return response;
  },

  async move (context, payload) {
    var response = await API.files.move (payload);
    return response;
  },

  async duplicate (context, payload) {
    var response = await API.files.duplicate (payload);
    return response;
  },

  async delete (context, payload) {
    var response = await API.files.delete (payload);
    return response;
  },

  async update (context, payload) {
    var response = await API.files.update (payload);
    return response;
  },
  async getDownloadUrl (context, payload) {
    var response = await API.files.getDownloadUrl (payload);
    return response;
  },

  async getPreviewUrl (context, payload) {
    var response = await API.files.getPreviewUrl (payload);
    return response;
  },

  async setEncodingStatusRequested (context, payload) {
    var response = await API.files.setEncodingStatusRequested (payload);
    return response;
  },
};

// getters
const getters = {
  getField,
  getFile: state => (id, model_type) => {
    var file = state[model_type]['uploads'].find (item => {
      return item.file_id == id;
    });
    return file;
  },

  getMediaFiles: state => (model_type, id) => {
    var file = state[model_type]['uploads'].find (file => {
      return file.file_id == id;
    });
    return file ? Object.assign ({}, file) : null;
  },

  getModelFiles: state => model_type => {
    return state[model_type].uploads;
  },

  getSubtitles: state => () => {
    var susbtitles = [];
    state['film']['uploads'].find (file => {
      if (file.is_subtitle) {
        susbtitles.push (file);
      }
    });
    return susbtitles;
  },
};

// mutations
const mutations = {
  updateField,
  set_files (state, payload) {
    //TODO:: is it right way to do this ??
    state[payload.model_type][DEFINES.COLLECTION_UPLOADS] = payload.files;
  },
  reset (state) {
    // acquire initial state
    const s = initialState ();
    Object.keys (s).forEach (key => {
      state[key] = s[key];
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
